import { Box, List, ListItem, ListIcon } from '@chakra-ui/react'
import NextLink from 'next/link'
import { ChevronRightIcon } from '@chakra-ui/icons'

export default function PostList({ posts }) {
  if (posts === 'undefined') return null

  return (
    <Box>
      {!posts && <div>No posts!</div>}
      <List>
        {posts?.map((post) => {
          const { title, slug } = post.fields
          console.log(post)
          return (
            <ListItem mt={10} key={slug}>
              <ListIcon as={ChevronRightIcon} />

              <NextLink href={{ pathname: `/post/${slug}` }}>
                {/* <a>{post.frontmatter.title}</a> */}
                <a>{title}</a>
              </NextLink>
            </ListItem>
          )
        })}
      </List>
    </Box>
  )
}
